import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/Card';
import { ArrowRight } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    title: 'Bistro Lights',
    description: 'Create a warm, inviting atmosphere with hanging string lights draped across patios, trees, or backyards. Perfect for entertaining and cozy outdoor evenings.',
    image: 'https://cdn.magicpatterns.com/uploads/gDZTvh2ireSXn3vpiBk9ne/bistro-lights.png',
    fullWidth: false
  }, {
    title: 'Architectural Lights',
    description: 'Highlight the unique design of your home with elegant lighting placed around walls, columns, and structural features.',
    image: 'https://cdn.magicpatterns.com/uploads/5TsNbk43GdmEb9FFUM9EfW/architectural-lights.webp',
    fullWidth: false
  }, {
    title: 'Landscape Lights',
    description: 'Accent your garden, lawn, or walkways with lights that elevate curb appeal and boost home value with lasting nighttime charm.',
    image: 'https://cdn.magicpatterns.com/uploads/88n9H6duUfUREiU7nFn7S1/landscape-lights.webp',
    fullWidth: false
  }, {
    title: 'Hardscape Lights',
    description: 'Illuminate retaining walls, stone steps, and patios with lighting that adds style, safety, and texture.',
    image: 'https://cdn.magicpatterns.com/uploads/rg5qMFskq3aPQW4cyvT7wo/hardscape-lights.webp',
    fullWidth: false
  }, {
    title: 'Sport Court Lights',
    description: 'Enjoy your basketball or pickleball court after dark with custom lighting that ensures visibility and safety.',
    image: 'https://cdn.magicpatterns.com/uploads/6UV4jL1AwAYj4zqM7aQttL/sportcourts-lights.webp',
    fullWidth: false
  }, {
    title: 'Backyard Lights',
    description: 'Highlight patios, decks, and seating areas with fixtures that create ambiance and enhance safety for outdoor entertaining.',
    image: 'https://cdn.magicpatterns.com/uploads/vC75qQasDSkqbiRMo6SZTo/backyard-lights.webp',
    fullWidth: false
  }, {
    title: 'Security Lights',
    description: 'Protect your property with strategically placed security lighting that deters intruders and provides peace of mind.',
    image: 'https://cdn.magicpatterns.com/uploads/tJGhJ69mpQiWkDi7tZjjnq/689bca823587f1007e59f91f.webp',
    fullWidth: true
  }];
  return <section className="w-full bg-[var(--brand-soft-white)] py-20 lg:py-28" data-id="element-180">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--brand-charcoal)] uppercase tracking-wider mb-4" data-id="element-183">
            Our Lighting Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-184">
            Premium outdoor lighting solutions for homes and businesses
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-185">
          {services.map((service, index) => <Card key={index} className={`overflow-hidden border-none shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:ring-2 hover:ring-[var(--brand-gold)] ${service.fullWidth ? 'md:col-span-2 lg:col-span-3' : ''}`} data-id="element-186">
              <div className={`w-full ${service.fullWidth ? 'h-64 lg:h-80' : 'h-56'} overflow-hidden relative`} data-id="element-187">
                <div className="absolute inset-0 bg-black/20 z-10" data-id="element-188"></div>
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-189" />
              </div>
              <CardHeader className="bg-white" data-id="element-190">
                <CardTitle className="text-xl font-bold text-[var(--brand-charcoal)]" data-id="element-191">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="bg-white pb-6" data-id="element-192">
                <CardDescription className="text-base text-gray-600 mb-6" data-id="element-193">
                  {service.description}
                </CardDescription>
                <a href="#" className="inline-flex items-center text-[var(--brand-gold)] font-medium hover:text-yellow-600 transition-colors" data-id="element-194">
                  Learn More <ArrowRight className="ml-2 w-4 h-4" data-id="element-195" />
                </a>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}